import { QuestOnboarding } from 'models/QuestOnboarding';
import { baseService } from 'modules/baseService';
import HttpClient from 'services/HttpClient';
import { getLastUpdatedAtQuery } from 'helpers/helperFunctions';

export const getQuestsOnboardings = baseService<
  string | undefined,
  QuestOnboarding[]
>((lastUpdatedAt) =>
  HttpClient.get(
    `/contentful/quests/onboardings${getLastUpdatedAtQuery(lastUpdatedAt)}`,
  ),
);
